"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _assets = require("../reducers/assets.js");
var _assets2 = require("../selectors/assets.js");
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Toolbar = _interopRequireDefault(require("./Toolbar"));
var _Breadcrumbs = _interopRequireDefault(require("./Breadcrumbs"));
var _ListView = _interopRequireDefault(require("./ListView"));
var _ThumbnailView = _interopRequireDefault(require("./ThumbnailView"));
var _reactDropzone = _interopRequireDefault(require("react-dropzone"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _config = require("../config.js");
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _numeral = _interopRequireDefault(require("numeral"));
var _notification = _interopRequireDefault(require("cccisd-icons/notification2"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var views = {
  thumbnail: _ThumbnailView["default"],
  list: _ListView["default"]
};
var getAssetSizeLimit = function getAssetSizeLimit(filter) {
  return filter === 'video' ? 50 * 1000 * 1000 : 5 * 1000 * 1000;
};
var Component = /*#__PURE__*/function (_React$Component) {
  function Component() {
    var _this;
    _classCallCheck(this, Component);
    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Component, [].concat(_args));
    _defineProperty(_this, "state", {
      loading: false,
      loadingPercentage: 0
    });
    _defineProperty(_this, "loadData", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this$props;
      var _args2 = arguments;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.setState({
              loading: true,
              loadingPercentage: null
            });
            _context.next = 3;
            return (_this$props = _this.props).loadData.apply(_this$props, _args2);
          case 3:
            _this.setState({
              loading: false
            });
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_this, "goToFolder", function (folderId, e) {
      e && e.preventDefault();
      _this.props.goToFolder(folderId);
    });
    _defineProperty(_this, "goFolderUp", function (e) {
      e && e.preventDefault();
      _this.props.goFolderUp();
    });
    _defineProperty(_this, "confirmUploading", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(acceptedFiles, rejectedFiles) {
        var folders, allFiles, allFilesPaths, updatedFiles, instruction, renderFile;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // Load files from missed folders and check if we have updated files
              folders = acceptedFiles.filter(function (item) {
                return item.path.includes('/');
              }).map(function (item) {
                return item.path.replace(/\/[^/]*$/, '');
              });
              _this.setState({
                loading: true,
                loadingPercentage: null
              });
              _context2.next = 4;
              return _this.props.loadSubFolders(folders);
            case 4:
              allFiles = _context2.sent;
              _this.setState({
                loading: false
              });
              allFilesPaths = allFiles.map(function (item) {
                return item.path;
              });
              updatedFiles = acceptedFiles.filter(function (item) {
                var path = _this.props.currentFolder.path + (item.path.includes('/') ? '' : '/') + item.path;
                return allFilesPaths.includes(path);
              }).map(function (item) {
                return item.path;
              }); // Don't show confirmation if it's just one file
              if (!(updatedFiles.length === 0 && acceptedFiles.length === 1 && rejectedFiles.length === 0)) {
                _context2.next = 10;
                break;
              }
              return _context2.abrupt("return");
            case 10:
              instruction = "Make sure that you are uploading right file types and the size of every file is less than ".concat((0, _numeral["default"])(getAssetSizeLimit(_this.props.globalFilter)).format('0 b'), ".");
              renderFile = function renderFile(file) {
                return /*#__PURE__*/_react["default"].createElement("li", {
                  key: file.path
                }, file.path, " (", (0, _numeral["default"])(file.size).format('0.00 b'), ")", ' ', updatedFiles.includes(file.path) && /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
                  title: "File will be updated"
                }, /*#__PURE__*/_react["default"].createElement("span", {
                  className: "text-danger"
                }, /*#__PURE__*/_react["default"].createElement(_notification["default"], null))));
              };
              if (!(acceptedFiles.length === 0)) {
                _context2.next = 15;
                break;
              }
              (0, _cccisdNotification["default"])({
                message: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
                  className: "alert alert-danger",
                  style: {
                    marginBottom: '0.7em'
                  }
                }, /*#__PURE__*/_react["default"].createElement("p", {
                  style: {
                    marginBottom: '0.5em'
                  }
                }, "All files are rejected and won't be uploaded:"), rejectedFiles.map(renderFile)), /*#__PURE__*/_react["default"].createElement("div", null, instruction)),
                inModal: true,
                showModalCloseButton: true,
                modalProps: {
                  title: 'Uploading files'
                }
              });
              return _context2.abrupt("return", Promise.reject());
            case 15:
              return _context2.abrupt("return", new Promise(function (resolve, reject) {
                (0, _cccisdConfirm["default"])({
                  message: 'Uploading files',
                  description: /*#__PURE__*/_react["default"].createElement("div", {
                    style: {
                      maxHeight: 'calc(100vh - 22rem)',
                      overflow: 'auto'
                    }
                  }, /*#__PURE__*/_react["default"].createElement("div", {
                    className: "alert alert-success",
                    style: {
                      margin: '0'
                    }
                  }, /*#__PURE__*/_react["default"].createElement("p", {
                    style: {
                      marginBottom: '0.5em'
                    }
                  }, /*#__PURE__*/_react["default"].createElement("strong", null, "Files to upload (", acceptedFiles.length, "):")), acceptedFiles.map(renderFile)), rejectedFiles.length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
                    className: "alert alert-danger",
                    style: {
                      margin: '0.7em 0'
                    }
                  }, /*#__PURE__*/_react["default"].createElement("p", {
                    style: {
                      marginBottom: '0.5em'
                    }
                  }, /*#__PURE__*/_react["default"].createElement("strong", null, "Rejected files (", rejectedFiles.length, "):")), rejectedFiles.map(renderFile)), /*#__PURE__*/_react["default"].createElement("div", null, instruction))),
                  confirmLabel: 'Upload',
                  abortLabel: 'Cancel'
                }).then(resolve).fail(reject);
              }));
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "onDropFiles", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(acceptedFiles, rejectedFiles) {
        var count, responses, _iterator, _step, file, resp, hasErrors, success;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this.confirmUploading(acceptedFiles, rejectedFiles);
            case 2:
              _this.setState({
                loading: true,
                loadingPercentage: 0
              });

              // TO-DO: refactor to send all files as one array in single request body
              count = 0;
              responses = [];
              _iterator = _createForOfIteratorHelper(acceptedFiles);
              _context3.prev = 6;
              _iterator.s();
            case 8:
              if ((_step = _iterator.n()).done) {
                _context3.next = 17;
                break;
              }
              file = _step.value;
              _context3.next = 12;
              return _this.props.addFile(file);
            case 12:
              resp = _context3.sent;
              responses.push(resp);
              _this.setState({
                loadingPercentage: ++count / acceptedFiles.length * 100
              });
            case 15:
              _context3.next = 8;
              break;
            case 17:
              _context3.next = 22;
              break;
            case 19:
              _context3.prev = 19;
              _context3.t0 = _context3["catch"](6);
              _iterator.e(_context3.t0);
            case 22:
              _context3.prev = 22;
              _iterator.f();
              return _context3.finish(22);
            case 25:
              _context3.next = 27;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 500);
              });
            case 27:
              _this.setState({
                loading: false
              });
              hasErrors = [];
              success = [];
              responses.forEach(function (resp) {
                var errs = resp.data.data.errors;
                if (errs && !Array.isArray(errs) && _typeof(errs) === 'object') {
                  errs = Object.keys(errs);
                }
                if (Array.isArray(errs) && errs.length > 0) {
                  hasErrors.push(resp);
                } else {
                  success.push(resp);
                }
              });
              hasErrors.forEach(function (resp) {
                (0, _cccisdNotification["default"])({
                  message: 'Could not add file',
                  type: 'danger',
                  data: resp.data.data.errors,
                  duration: 0
                });
              });
              if (success.length) {
                (0, _cccisdNotification["default"])("".concat(success.length, " ").concat(success.length === 1 ? 'file has ' : 'files have ', " been added successfully"));
              }
            case 33:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[6, 19, 22, 25]]);
      }));
      return function (_x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "openFileDialog", function () {
      _this.dropzone.open();
    });
    return _this;
  }
  _inherits(Component, _React$Component);
  return _createClass(Component, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.init();
      this.props.setGlobalFilter(this.props.globalFilter);
      this.loadData({
        selectedFile: this.props.initialSelectedFile,
        initialLoad: true
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.currentFolderId !== this.props.currentFolderId && prevProps.currentFolderId !== 0 && this.props.currentFolderId !== 0) {
        this.loadData();
      }
      if (prevProps.globalFilter !== this.props.globalFilter) {
        this.props.setGlobalFilter(this.props.globalFilter);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$extra,
        _this$props$extra2,
        _this2 = this;
      var View = views[this.props.viewMode];
      var accept = (_config.globalFilters[this.props.globalFilter] || {}).accept;
      var body = /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginBottom: '0.5em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_Toolbar["default"], {
        openFileDialog: this.openFileDialog,
        allowTts: (_this$props$extra = this.props.extra) === null || _this$props$extra === void 0 ? void 0 : _this$props$extra.allowTts,
        ttsContent: (_this$props$extra2 = this.props.extra) === null || _this$props$extra2 === void 0 ? void 0 : _this$props$extra2.ttsContent,
        onImageUpdate: this.props.onImageUpdate
      })), /*#__PURE__*/_react["default"].createElement(_reactDropzone["default"], _extends({
        ref: function ref(elem) {
          _this2.dropzone = elem;
        },
        onDrop: this.onDropFiles,
        multiple: true,
        noClick: true,
        noKeyboard: true,
        maxSize: getAssetSizeLimit(this.props.globalFilter)
      }, accept && {
        accept: accept
      }), function (_ref4) {
        var isDragActive = _ref4.isDragActive,
          getRootProps = _ref4.getRootProps,
          getInputProps = _ref4.getInputProps;
        return /*#__PURE__*/_react["default"].createElement("div", _extends({
          style: {
            position: 'relative'
          }
        }, getRootProps()), /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames2["default"])(_style["default"].dropArea, _defineProperty({}, _style["default"].active, isDragActive))
        }, "Drop files here"), /*#__PURE__*/_react["default"].createElement("input", getInputProps()), /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].body,
          "data-picker-body": true
        }, /*#__PURE__*/_react["default"].createElement(View, {
          currentFolderId: _this2.props.currentFolderId,
          currentFolderData: _this2.props.currentFolderData,
          selectedFolderUp: _this2.props.selectedFolderUp,
          selectedFiles: _this2.props.selectedFiles,
          selectedFolders: _this2.props.selectedFolders,
          selectedFile: _this2.props.selectedFile,
          selectedFolder: _this2.props.selectedFolder,
          goToFolder: _this2.goToFolder,
          goFolderUp: _this2.goFolderUp,
          selectFile: _this2.props.selectFile,
          selectFolder: _this2.props.selectFolder,
          selectNext: _this2.props.selectNext,
          showInfoModal: _this2.props.showInfoModal,
          isTopFolder: _this2.props.isTopFolder
        })));
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '0.5em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_Breadcrumbs["default"], null)));
      return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: this.state.loading,
        percentage: this.state.loadingPercentage
      }, this.props.render ? this.props.render({
        body: body,
        selectedFile: this.props.selectedFile
      }) : body);
    }
  }]);
}(_react["default"].Component);
_defineProperty(Component, "propTypes", {
  initialSelectedFile: _propTypes["default"].number,
  globalFilter: _propTypes["default"].string,
  render: _propTypes["default"].func,
  currentFolder: _propTypes["default"].object,
  currentFolderId: _propTypes["default"].number,
  currentFolderData: _propTypes["default"].object,
  selectedFolderUp: _propTypes["default"].bool,
  selectedFiles: _propTypes["default"].array,
  selectedFolders: _propTypes["default"].array,
  selectedFile: _propTypes["default"].object,
  selectedFolder: _propTypes["default"].object,
  init: _propTypes["default"].func,
  loadData: _propTypes["default"].func,
  loadSubFolders: _propTypes["default"].func,
  goToFolder: _propTypes["default"].func,
  goFolderUp: _propTypes["default"].func,
  selectFile: _propTypes["default"].func,
  selectFolder: _propTypes["default"].func,
  selectNext: _propTypes["default"].func,
  showInfoModal: _propTypes["default"].func,
  addFile: _propTypes["default"].func,
  viewMode: _propTypes["default"].string,
  setGlobalFilter: _propTypes["default"].func,
  isTopFolder: _propTypes["default"].bool,
  onImageUpdate: _propTypes["default"].func
});
_defineProperty(Component, "defaultProps", {
  globalFilter: 'none'
});
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    isTopFolder: state.resources.assets.currentFolderId === state.resources.assets.topFolderId,
    currentFolderId: state.resources.assets.currentFolderId,
    selectedFolderUp: state.resources.assets.selectedFolderUp,
    selectedFiles: state.resources.assets.selectedFiles,
    selectedFolders: state.resources.assets.selectedFolders,
    selectedFile: (0, _assets2.getOneSelectedFile)(state.resources.assets),
    selectedFolder: (0, _assets2.getOneSelectedFolder)(state.resources.assets),
    currentFolderData: (0, _assets2.getCurrentFolderData)(state.resources.assets),
    currentFolder: (0, _assets2.getCurrentFolder)(state.resources.assets),
    viewMode: state.resources.assets.viewMode
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, {
  init: _assets.init,
  loadData: _assets.loadData,
  loadSubFolders: _assets.loadSubFolders,
  goToFolder: _assets.goToFolder,
  goFolderUp: _assets.goFolderUp,
  selectFile: _assets.selectFile,
  selectFolder: _assets.selectFolder,
  selectNext: _assets.selectNext,
  showInfoModal: _assets.showInfoModal,
  addFile: _assets.addFile,
  setGlobalFilter: _assets.setGlobalFilter
})(Component);